
import CitiesList from '../cities/usCity.json'

const compare = (a, b) => {
  if (a.name < b.name) return -1;
  if (a.name > b.name) return 1;
  return 0;
};

export const GetCitiesOfState = (countryCode, stateCode) => {
  const cities = CitiesList.filter(value => {
    return value.countryCode == countryCode && value.stateCode == stateCode;
  });
  return cities.sort(compare);
}
